// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
export const parseCurrentUser = (user) => {
  return {
    firstName: user?.profile?.given_name,
    lastName: user?.profile?.family_name,
    email: user?.profile?.email
  }
}

export const getUserNameChars = (user) => {
  return `${user?.firstName?.charAt(0)}${user?.lastName?.charAt(0)}`
}
